<template>
  <div id="mainImpagos" class="grid center">
    <div class="xl:col-2 md:col-12" />
    <div class="xl:col-8 md:col-12">
      <div class="card backgroundTransparent">
        <div
          class="dashboardInfo"
          :style="{
            backgroundImage: 'url(' + require('@/assets/clients.png') + ')',
          }"
        >
          <div class="contentInfo">
            <h1>
              {{
                new Date().getHours() >= 12
                  ? this.$t("altaImpago.saludoTarde")
                  : this.$t("altaImpago.saludoManiana")
              }}
            </h1>
            <h2>{{ this.$t("altaImpago.textos.saludoPregunta") }}</h2>
          </div>
        </div>
        <TabView @tab-change="onTabChange" :activeIndex="tabIndex">
          <TabPanel id="claim-debt">
            <template slot="header">
              <i class="pi pi-file-o iconSize"></i>
              <span class="tabTitleText ml-2">{{
                this.$t("altaImpago.reclamarImpago")
              }}</span>
            </template>
            <AltaImpagoMenu />
          </TabPanel>
          <TabPanel id="my-operations">
            <template slot="header">
              <i class="pi pi-folder-open iconSize"></i>
              <span class="tabTitleText ml-2">{{
                this.$t("altaImpago.misExpedientes")
              }}</span>
            </template>
            <ExpedientesMain />
          </TabPanel>
          <TabPanel id="search-debt">
            <template slot="header">
              <i class="pi pi-fw pi-search iconSize"></i>
              <span class="tabTitleText ml-2">{{
                this.$t("altaImpago.consultarFichero")
              }}</span>
            </template>
            <ConsultaFicheroMain />
          </TabPanel>
          <TabPanel id="my-searches">
            <template slot="header">
              <i class="pi pi-plus-circle iconSize"></i>
              <span class="tabTitleText ml-2">{{
                this.$t("altaImpago.misConsultas")
              }}</span>
            </template>
            <ConsultasTabMain />
          </TabPanel>
        </TabView>
      </div>
    </div>
    <div class="xl:col-2 md:col-12" />
    <Dialog
      :header="$t('altaImpago.labels.avisoPago')"
      :modal="true"
      :visible.sync="displayPaymentWarning"
      :style="{ width: '65vw', 'text-align': 'left' }"
      class="modal"
    >
      <p style="white-space: pre-wrap">
        {{ $t("altaImpago.textos.avisoPago") }}
      </p>
      <template #footer>
        <Button
          @click.prevent="navigateToMoreInfo"
          :label="$t('common.buttons.moreInfo')"
          class="p-button-primary"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import AltaImpagoMenu from "@/components/portal-cliente/AltaImpagoMenu";
import ExpedientesMain from "@/components/portal-cliente/Expedientes/ExpedientesMain";
import ConsultasTabMain from "@/components/portal-cliente/MisConsultas/ConsultasTabMain";
import ConsultaFicheroMain from "@/components/portal-cliente/ConsultaFichero/ConsultaFicheroMain";
import RoutesMixin from "@/utils/routes";

export default {
  name: "AltaasdImpago",
  mixins: [RoutesMixin],
  data() {
    return {
      displayPaymentWarning: false,
      tabIndex: 0,
      tabNames: [
        "claim-debt",
        "my-operations",
        "search-debt",
        "my-searches"
      ]
    };
  },
  created() {
    this.setTabIdx();
  },
  methods: {
    setTabIdx() {
      if (this.$route.params.index !== undefined) this.tabIndex = this.$route.params.index;
    },
    onTabChange(e) {
      this.tabIndex = e.index;
      this.to({
        name: 'dashboard',
        params: {
          tab: this.tabNames[e.index],
          index: e.index
        }
      })
    },
    navigateToMoreInfo() {
      window.open(
        "https://ayuda.iciredimpagados.com/hc/es-es/articles/4413391923730"
      );
    },
  },
  components: {
    AltaImpagoMenu,
    ExpedientesMain,
    ConsultaFicheroMain,
    ConsultasTabMain,
  },
  mounted() {
    if (this.$route.query.orderID) {
      this.displayPaymentWarning = true;
    }
  },
};
</script>

<style lang="scss" scoped>
</style>